import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowRight, Quote } from "lucide-react";
import Reveal from "./Reveal";

/**
 * Founder story section — explicit, named, with a clear "Eric, Founder" attribution.
 * Replaces the old "testimonial" framing with a proper origin block.
 */
export default function FounderStory() {
  return (
    <section id="founder" className="py-24 md:py-32 bg-[#0f1724] text-white relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 30%, rgba(72,106,143,0.5) 0%, transparent 45%), radial-gradient(circle at 85% 70%, rgba(229,214,178,0.3) 0%, transparent 45%)",
        }}
      />
      <div className="relative max-w-4xl mx-auto px-6">
        <Reveal>
          <div className="text-center mb-12">
            <p className="font-mono-eyebrow text-[#8aa7c4] mb-3">A LETTER FROM THE FOUNDER</p>
            <h2 className="font-display text-[40px] md:text-[56px] leading-[1.05] tracking-tight">
              I built this because{" "}
              <span className="italic font-light text-[#8aa7c4]">I needed it.</span>
            </h2>
          </div>
        </Reveal>
        <Reveal>
          <div className="rounded-3xl bg-white/[0.04] border border-white/10 backdrop-blur-sm p-8 md:p-12">
            <Quote className="text-[#8aa7c4] mb-6" size={32} />
            <div className="font-body text-[16px] md:text-[17px] leading-[1.8] text-white/90 space-y-5 whitespace-pre-line">
{`I spent 40 years winging it. No mentor. No real coach. No system.

I built a business with my father and watched him use my own success against me. Every win was weaponized. Every step forward came with a cost. When I finally walked away, I had no one checking in, no plan, and no map.

I tried therapy. I tried journaling. I tried 14 productivity apps. Nothing tied it together. Nothing remembered me from one day to the next.

So I built Ascend Higher.

It's not therapy. It's not a chatbot you talk to once. It's an AI life coach with persistent memory, organized around five life pillars — money, health, spirituality, relationships, and endgame — that turns scattered days into a real roadmap.

If you've ever felt like you're running on chaos, this is for you. I hope it helps you the way I needed it to help me.`}
            </div>
            <div className="flex items-center gap-4 pt-7 mt-7 border-t border-white/10">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#486a8f] to-[#3a5a7c] flex items-center justify-center font-display text-white">
                E
              </div>
              <div>
                <p className="font-body font-medium text-white">Eric</p>
                <p className="font-body text-sm text-white/60">Founder, Ascend Higher</p>
              </div>
            </div>
          </div>
        </Reveal>
        <Reveal>
          <div className="text-center mt-12 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/beta">
              <Button className="h-12 px-7 rounded-full bg-white hover:bg-[#faf6ec] text-[#0f1724] font-medium">
                Become a beta tester
              </Button>
            </Link>
            <Link to="/start">
              <Button className="h-12 px-7 rounded-full bg-[#486a8f] hover:bg-[#3a5a7c] text-white font-medium">
                Start free trial <ArrowRight size={14} className="ml-2" />
              </Button>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
